import './App.css';
import Details from './Component/Info';
function App() {
  return (
       <div className="App">
          <Details/>
      </div>
     );
    }
    
    export default App;
